import { css } from "@emotion/core";
import { FC } from "react";
import { Box, Center, Frame, Stack, Switcher, Text } from "../common";

export const CityLanding: FC<any> = props => (
  <Box>
    <Center gutters="var(--s2)" maxWidth="var(--max-width)">
      <Switcher threshold="var(--min-width)" space="var(--s-2)" max={2}>
               <Box style={{ flexGrow: 1}}
          css={css`
                 @media screen and (min-width: 900px) {
                   padding-top: var(--s2);
                   
                   
                 }
               `}
        >
                   {/* <Frame numerator={6} denominator={5}> */}
             <img
              src={props.city_image}
            alt={props.title}
  
            css={css`
                 @media screen and (min-width: 1200px) {
                   width:400px
                   
                 }
                  @media screen and (max-width: 1200px) {
                   width:100%
                   
                 }
               `}
              // style={{  width: "400px" }}
            />
           
        </Box>
               <Stack
          space="var(--s0)"
          // justify="center"
          css={css`
            @media screen and (min-width: 100%) {
              padding-right: var(--s5);
              margin-top :var(--s3);
              

            }
          `}
        >
          <Text as="h1" variant="h1" style={{marginTop:'14%'}}>
            {props.title}
          </Text>

          <Text as="h1" variant="h4" color="light" style={{fontWeight: 'bold',}}>
            {props.sub_title}
          </Text>


          {props.description.map((item) => {
            return <Text variant="p" color="light" style={{textAlign:"justify"}} >
              {item}
            </Text>
          })}
        </Stack>

       </Switcher>
     </Center>
  </Box>


  // <Box>
  //   <Center gutters="var(--s2)" maxWidth="var(--max-width)">
  //     <Switcher threshold="var(--min-width)" space="var(--s-2)" max={2}>

  //       <Box style={{ flexGrow: 1 }}
  //         css={css`
  //                @media screen and (min-width: 900px) {
  //                  padding-top: var(--s2);
                   
  //                }
  //              `}
  //       >
  //         {/* <Frame numerator={6} denominator={5}> */}
  //           <img
  //             src={props.city_image}
  //             alt={props.title}
  //             style={{ height: "auto", width: "400px" }}
  //           />
  //         {/* </Frame> */}
  //       </Box>

  //       <Stack
  //         space="var(--s0)"
  //         // justify="center"
  //         css={css`
  //           @media screen and (min-width: 100%) {
  //             padding-right: var(--s5);
  //             margin-top :var(--s3);
              

  //           }
  //         `}
  //       >
  //         <Text as="h1" variant="h1">
  //           {props.title}
  //         </Text>

  //         <Text as="h1" variant="h4" color="light" style={{fontWeight: 'bold',}}>
  //           {props.sub_title}
  //         </Text>


  //         {props.description.map((item) => {
  //           return <Text variant="p" color="light" style={{textAlign:"justify"}} >
  //             {item}
  //           </Text>
  //         })}
  //       </Stack>

  //     </Switcher>
  //   </Center>
  // </Box>
)